<template>
	<div>
			<clue-data-trend-pic></clue-data-trend-pic>
			<!--<clue-data-detail></clue-data-detail>-->
	</div>
</template>

<script>
import ClueDataDetail from './children/clueDataDetail'
import ClueDataTrendPic from './children/clueDataTrendPic'
import BasicPager from '../../mixins/BasicPager'
import SysModel from '../../framework/models/sysModel'

export default {
  name: 'clue-data-trend',
  extends: BasicPager,
  data: function () {
    return {
      datas: []
    }
  },
  created: function () {
    let params = this.$route.params

    if (params.token) {
      this.crmLogin(params.token)
    }
  },
  components: {
    ClueDataDetail,
    ClueDataTrendPic
  },
  methods: {
    crmLogin: function (token) {
      let _this = this
      let listener_1 = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.publicKey = datas.publicKey
          _this.exponent = datas.exponent
          $.jCryption.crypt.setPublicKey(datas.publicKey)

          let loginData = {
            'token': token
          }
          let jsonStr = JSON.stringify(loginData)
          let subJson = _this.jsonSubstring(jsonStr)

          var res = $.jCryption.crypt.encrypt(subJson)

          let params = {
						 'param': res
          }
          SysModel.crmLogin(_this, params, listener)
        }
      }
			 SysModel.getPublicKey(_this, listener_1)

      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          datas.loginTime = new Date().getTime()
          _this.saveLoginInfo(datas)
          // 跳转
          let rootPath = 'channelDataTrend'

          let userInfo = JSON.parse(localStorage.userInfo)

          if (userInfo) {
            _this.$router.push('/home/clueDataTrend')
            window.location.reload()
          }
        }
      }
    },
    jsonSubstring: function (str) {
      let len = str.length
      return str.substring(1, len - 1)
    }
  }
}
</script>

<style media="screen">

</style>
